import "./UploadReportHera.css";
import "leaflet/dist/leaflet.css";
import FiltroCategorie from "../../components/FiltroCategorie/FiltroCategorie";
import DatePickerModal from "../../components/DatePickerModal/DatePickerModal";
import RotateDevice from "../../components/RotateDevice/RotateDevice";

import axios from "axios";
import L from "leaflet";
import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import { MOCKED_HERA_CATEGORIES } from "../../mocks/MockedCategories";
import Lf23Loader from "../../components/Lf23Loader";

// Fix Leaflet default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export const UploadReportHera = () => {
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
    const navigate = useNavigate();

    // Mappa per tradurre i titoli delle colonne
    const getColumnTitle = (col) => {
        const titlesMap = {

            // Report COOP
            "segreteria": "SEGR.",
            "ods_totali": "TOT",
            "ods_da_inviare_a_sac": "SAC",
            "ods_con_errori": "ERR",
            "ods_con_errori_gestiti": "ERR OK",
            "ods_ini_stato_fins_prog": "FINS/PROG",
            "ods_non_inviati_a_sac": "CONS",
            "ods_in_stato_asac_isac": "ASAC/ISAC",
            "ods_aperti_meno_di_1_ora": "TIME <1H",
            "ods_aperti_piu_di_12_ore": "TIME >12H",
            "ods_raccolta_senza_letture": "NO LETTURE",
            "servizi_da_agenda_con_posizioni_non_confermate": "NO CONFERMA POS",
            "ods_spazzamento_senza_tracking": "NO TRACKING",

            // Report ODS
            "servizio": "ODS",
            "codice_itinerario": "ITINERARIO",
            "desc_itinerario": "DESC ITINERARIO",
            "ods_con_giustificativo": "GIUSTIFICATIVO",
            "ods_ini_stato_fins_prog": "FINS/PROG",
            "ods_non_inviati_corr_a_sdc_inviati_in_consunt": "CONS",
            "ods_gestiti_min_1_h": "TIME <1H",
            "ods_gestiti_magg_12_h": "TIME >12H",
            "ods_senza_letture_no_spazzamenti": "NO LETTURA",
            "no_letture_servizi_da_agenda": "NO CONFERMA POS",
            "errori_tracking_spazzamento": "NO TRACKING",
            "errori_su_ods_totali": "ERRORI",
            "tipo_causale_": "TIPO CAUSALE",
            "valore_concordato": "VAL. CONCORDATO",
            "stato_errore": "STATO ERRORE",
            "ignora": "IGNORA",
            "note_ignora": "NOTE",
        };

        return titlesMap[col] || col.replace(/_/g, " ").toUpperCase();
    };

    // Mappa per i nomi completi in hover
    const getColumnTooltip = (col) => {
        const tooltipsMap = {
            // Report ODS - descrizioni complete
            "servizio": "SERVIZIO",
            "codice_itinerario": "CODICE ITINERARIO",
            "desc_itinerario": "DESCRIZIONE ITINERARIO",
            "ods_con_giustificativo": "ODS CON GIUSTIFICATIVO",
            "ods_ini_stato_fins_prog": "ODS IN STATO FINS/PROG",
            "ods_non_inviati_corr_a_sdc_inviati_in_consunt": "ODS NON INVIATO A SAC",
            "ods_in_stato_asac_isac": "ODS IN STATO ASAC/ISAC",
            "ods_gestiti_min_1_h": "ODS APERTO MENO DI 1 ORA",
            "ods_gestiti_magg_12_h": "ODS APERTO PIÙ DI 12 ORE",
            "ods_senza_letture_no_spazzamenti": "ODS RACCOLTA SENZA LETTURE",
            "no_letture_servizi_da_agenda": "SERVIZI DA AGENDA CON POSIZIONI NON CONFERMATE",
            "errori_tracking_spazzamento": "ODS SPAZZAMENTO SENZA TRACKING",
            "errori_su_ods_totali": "ERRORI SU ODS",
            "tipo_causale_": "TIPO CAUSALE",
            "valore_concordato": "VALORE CONCORDATO",
            "stato_errore": "STATO ERRORE (aperto, risolto, non in errore)",
            "ignora": "FLAG PER IGNORARE L'ODS",
            "note_ignora": "NOTE ASSOCIATE ALL'ODS",
        };

        return tooltipsMap[col] || col.replace(/_/g, " ").toUpperCase();
    };

    // Configurazione tipi di upload
    const uploadTypes = [
        {
            key: "anagrafica-itin",
            title: "Anagrafica Itinerario",
            description: "Carica il file Excel con i dati di anagrafica",
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
            )
        },
        {
            key: "report-ods-hera",
            title: "Report Ods Hera",
            description: "Carica il file Excel con i dati report di Hera",
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 17H5a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm12-2h-4a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zM5 11V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2z"></path>
                </svg>
            )
        },
        {
            key: "report-posizioni-hera",
            title: "Report Posizioni Hera",
            description: "Carica il file Excel con le posizioni di Hera",
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                </svg>
            )
        },
    ];

    // State per gestione file
    const [selectedFiles, setSelectedFiles] = useState({
        "anagrafica-itin": null,
        "report-ods-hera": null,
        "report-posizioni-hera": null,
    });
    const [loading, setLoading] = useState({
        "anagrafica-itin": false,
        "report-ods-hera": false,
        "report-posizioni-hera": false,
    });
    const [lastUploads, setLastUploads] = useState({
        "anagrafica-itin": null,
        "report-ods-hera": null,
        "report-posizioni-hera": null,
    });

    // State per UI
    const [showUploadPanel, setShowUploadPanel] = useState(false);
    const [showFiltersPanel, setShowFiltersPanel] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "", category: "" });
    const [anagraficaErrors, setAnagraficaErrors] = useState({ show: false, codici: [], category: "" });
    const [columnErrors, setColumnErrors] = useState({ show: false, columns: [], category: "" });
    const [duplicateErrors, setDuplicateErrors] = useState({ show: false, itinerari: [], category: "" });

    // Opzioni disponibili per stato errore
    const statoErroreOptions = [
        { value: 'aperto', label: 'Aperto' },
        { value: 'risolto', label: 'Risolto' },
        { value: 'non_in_errore', label: 'Non in errore' }
    ];

    // Opzioni per filtro Ignora
    const ignoraOptions = [
        { value: null, label: 'Tutti' },
        { value: true, label: 'Ignorati' },
        { value: false, label: 'Non ignorati' }
    ];

    // State per tabella e filtri
    const [filteredTableData, setFilteredTableData] = useState([]);
    const [colonne, setColonne] = useState([]);
    const [listaSegreteria, setListaSegreteria] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedStatoErrore, setSelectedStatoErrore] = useState(['aperto', 'risolto', 'non_in_errore']); // Default: tutti selezionati
    const [tableLoading, setTableLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    // State per filtri avanzati Report ODS
    const [odsFilterOptions, setOdsFilterOptions] = useState({ servizi: [], codiciItinerario: [], tipiErrore: [] });
    const [selectedServizi, setSelectedServizi] = useState([]);
    const [selectedCodiciItinerario, setSelectedCodiciItinerario] = useState([]);
    const [selectedTipiErrore, setSelectedTipiErrore] = useState([]);
    const [selectedIgnora, setSelectedIgnora] = useState(false); // null = tutti, true = solo ignorati, false = solo non ignorati (default)

    // State per editing note inline
    const [editingNoteServizio, setEditingNoteServizio] = useState(null);
    const [editingNoteValue, setEditingNoteValue] = useState('');

    // State per tooltip colonne
    const [hoveredCol, setHoveredCol] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    // State per ordinamento
    const [sortConfig, setSortConfig] = useState({ column: null, direction: null });

    // State per Report Abiti
    const [abitiData, setAbitiData] = useState([]);
    const [abitiAggregation, setAbitiAggregation] = useState('giorno');
    const [abitiPage, setAbitiPage] = useState(0);
    const [abitiFiltersVisible, setAbitiFiltersVisible] = useState(true);
    const [abitiDetailModal, setAbitiDetailModal] = useState({ show: false, date: null, data: null, loading: false });
    const [abitiChartTooltip, setAbitiChartTooltip] = useState({ show: false, x: 0, y: 0, data: null });

    // Fullscreen states
    const [isFullscreenTable, setIsFullscreenTable] = useState(false);
    const [isFullscreenAbitiChart, setIsFullscreenAbitiChart] = useState(false);
    const [isFullscreenAbitiTable, setIsFullscreenAbitiTable] = useState(false);
    const [abitiSelectedHera, setAbitiSelectedHera] = useState(null);   // { index, address, loading }
    const [abitiSelectedInteracta, setAbitiSelectedInteracta] = useState(null); // { index, address, loading }
    const [abitiMapLoading, setAbitiMapLoading] = useState(false);
    const abitiMapRef = useRef(null);
    const abitiMapInstanceRef = useRef(null);
    const abitiMarkerHeraRef = useRef(null);
    const abitiMarkerInteractaRef = useRef(null);
    const ABITI_PAGE_SIZE = 20;

    // Helper per date di default (ultimi 7 giorni)
    const getDefaultDateRange = () => {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);
        const formatDate = (date) => date.toISOString().split('T')[0];
        return { from: formatDate(sevenDaysAgo), to: formatDate(today) };
    };

    const defaultDates = getDefaultDateRange();
    const [fromDate, setFromDate] = useState(defaultDates.from);
    const [toDate, setToDate] = useState(defaultDates.to);
    const [selectedSegreteria, setSelectedSegreteria] = useState([]);

    // Effetti
    // Escape key handler for fullscreen
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                setIsFullscreenTable(false);
                setIsFullscreenAbitiChart(false);
                setIsFullscreenAbitiTable(false);
            }
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, []);

    useEffect(() => {
        const initPage = async () => {
            setInitialLoading(true);
            try {
                await Promise.all([
                    fetchLastUploads(),
                    getAllSegreteria()
                ]);
            } finally {
                setInitialLoading(false);
            }
        };
        initPage();
    }, []);

    useEffect(() => {
        if (selectedCategory === "REPORT ODS") {
            applyFilter();
        }
    }, [selectedStatoErrore]);

    // Funzioni API
    const fetchLastUploads = async () => {
        try {
            const uploads = {};
            for (const type of uploadTypes) {
                const response = await axios.get(`${API_URL}/hera/lastUpload/${type.key}`);
                uploads[type.key] = response.data.lastUpload
                    ? new Date(response.data.lastUpload).toLocaleString("it-IT", { timeZone: "Europe/Rome" })
                    : null;
            }
            setLastUploads(uploads);
        } catch (error) {
            console.error("Errore nel recupero degli ultimi caricamenti:", error);
        }
    };

    const getAllSegreteria = async () => {
        try {
            const res = await axios.get(`${API_URL}/hera/getAll/repo-segreterie`);
            setListaSegreteria(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    const getRepoCoop = async (dateFrom = fromDate, dateTo = toDate, segreterie = selectedSegreteria) => {
        try {
            const res = await axios.get(`${API_URL}/hera/getAll/repoCoop`, {
                params: {
                    dataInizio: dateFrom,
                    dataFine: dateTo,
                    segreterie: segreterie
                }
            });
            setFilteredTableData(res.data);
            if (res.data.length > 0) {
                setColonne(Object.keys(res.data[0]));
            }
        } catch (error) {
            console.error('Errore durante il recupero dei report:', error);
        }
    };

    const getRepoOds = async (
        statoErrore,
        dateFrom = fromDate,
        dateTo = toDate,
        segreterie = selectedSegreteria,
        servizi = selectedServizi,
        codiciItinerario = selectedCodiciItinerario,
        tipiErrore = selectedTipiErrore,
        ignora = selectedIgnora
    ) => {
        try {
            const res = await axios.get(`${API_URL}/hera/getAll/repoOds`, {
                params: {
                    dataInizio: dateFrom,
                    dataFine: dateTo,
                    segreterie: segreterie,
                    statoErrore: statoErrore,
                    servizi: servizi.length > 0 ? servizi : undefined,
                    codiciItinerario: codiciItinerario.length > 0 ? codiciItinerario : undefined,
                    tipiErrore: tipiErrore.length > 0 ? tipiErrore : undefined,
                    ignora: ignora !== null ? ignora : undefined
                }
            });

            const reportWithDataFiltered = res.data.map(item => {
                const { tipo_errore, ...rest } = item; // Escludi tipo_errore dalla visualizzazione
                return {
                    ...rest,
                    data: new Date(item.data).toLocaleDateString("it-IT")
                };
            });

            setFilteredTableData(reportWithDataFiltered);
            if (reportWithDataFiltered.length > 0) {
                setColonne(Object.keys(reportWithDataFiltered[0]));
            }
        } catch (error) {
            console.error('Errore durante il recupero dei report:', error);
        }
    };

    // Carica tutte le opzioni filtri ODS (senza filtro data per avere sempre tutte le opzioni disponibili)
    const fetchOdsFilterOptions = async () => {
        try {
            const res = await axios.get(`${API_URL}/hera/getAll/repoOds/filter-options`);
            setOdsFilterOptions(res.data);
        } catch (error) {
            console.error('Errore durante il recupero delle opzioni filtri:', error);
        }
    };

    // API per Report Abiti
    const getRepoAbiti = async (dateFrom = fromDate, dateTo = toDate) => {
        try {
            const res = await axios.get(`${API_URL}/hera/getAll/repoAbiti`, {
                params: { dataInizio: dateFrom, dataFine: dateTo, aggregazione: 'giorno' }
            });
            setAbitiData(res.data);
            setAbitiPage(0);
        } catch (error) {
            console.error('Errore durante il recupero dei report abiti:', error);
        }
    };

    const getRepoAbitiDetail = async (date) => {
        try {
            const res = await axios.get(`${API_URL}/hera/getAll/repoAbiti/detail/${date}`);
            return res.data;
        } catch (error) {
            console.error('Errore durante il recupero del dettaglio report abiti:', error);
            return { tagsH: [], indH: [], tagsI: [], indI: [] };
        }
    };

    // Funzione per aggiornare annotazione ODS (ignora/note)
    const updateOdsAnnotation = async (servizio, ignora, note) => {
        try {
            await axios.put(`${API_URL}/hera/ods-annotation`, {
                servizio,
                ignora,
                note
            });

            // Aggiorna lo state locale
            setFilteredTableData(prevData =>
                prevData.map(row =>
                    row.servizio === servizio
                        ? { ...row, ignora, note_ignora: note }
                        : row
                )
            );
        } catch (error) {
            console.error('Errore durante l\'aggiornamento dell\'annotazione:', error);
        }
    };

    // Handler per toggle ignora
    const handleIgnoraToggle = async (servizio, currentIgnora, currentNote) => {
        const newIgnora = !currentIgnora;
        await updateOdsAnnotation(servizio, newIgnora, currentNote);
    };

    // Handler per salvare nota
    const handleSaveNote = async (servizio, currentIgnora) => {
        await updateOdsAnnotation(servizio, currentIgnora, editingNoteValue);
        setEditingNoteServizio(null);
        setEditingNoteValue('');
    };

    // Handlers
    const handleCategorySelect = async (category) => {
        setSelectedCategory(category);
        setFilteredTableData([]);
        setTableLoading(true);
        setSortConfig({ column: null, direction: null });

        // Reset filtri avanzati ODS quando si cambia categoria
        setSelectedServizi([]);
        setSelectedCodiciItinerario([]);
        setSelectedTipiErrore([]);
        setSelectedIgnora(false);

        try {
            if (category === "REPORT COOP") {
                await getRepoCoop();
                // Imposta ordinamento di default per "segreteria" in modo ascendente
                setSortConfig({ column: 'segreteria', direction: 'asc' });
            } else if (category === "REPORT ODS") {
                // Carica le opzioni filtri e i dati in parallelo
                await Promise.all([
                    fetchOdsFilterOptions(),
                    getRepoOds(selectedStatoErrore, fromDate, toDate, selectedSegreteria, [], [], [], false)
                ]);
                // Imposta ordinamento di default per "data" in modo descendente
                setSortConfig({ column: 'data', direction: 'desc' });
            } else if (category === "REPORT ABITI") {
                setAbitiAggregation('giorno');
                setAbitiFiltersVisible(true);
                await getRepoAbiti(fromDate, toDate);
            }
        } finally {
            setTableLoading(false);
        }
    };

    const applyFilter = async () => {
        setTableLoading(true);
        try {
            if (selectedCategory === "REPORT COOP") {
                await getRepoCoop();
                setSortConfig({ column: 'segreteria', direction: 'asc' });
            } else if (selectedCategory === "REPORT ODS") {
                await getRepoOds(
                    selectedStatoErrore,
                    fromDate,
                    toDate,
                    selectedSegreteria,
                    selectedServizi,
                    selectedCodiciItinerario,
                    selectedTipiErrore,
                    selectedIgnora
                );
                setSortConfig({ column: 'data', direction: 'desc' });
            } else if (selectedCategory === "REPORT ABITI") {
                await getRepoAbiti(fromDate, toDate);
            }
        } catch (err) {
            console.error("Errore nella fetch:", err);
        } finally {
            setTableLoading(false);
        }
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
            alert("La data iniziale non può essere successiva alla data finale.");
            return;
        }
        applyFilter();
    };

    const handleReset = async () => {
        const defaultDates = getDefaultDateRange();
        const defaultStatoErrore = ['aperto', 'risolto', 'non_in_errore'];
        setFromDate(defaultDates.from);
        setToDate(defaultDates.to);
        setSelectedSegreteria([]);
        setSelectedStatoErrore(defaultStatoErrore);
        setSelectedServizi([]);
        setSelectedCodiciItinerario([]);
        setSelectedTipiErrore([]);
        setSelectedIgnora(false);
        setFilteredTableData([]);

        setTableLoading(true);
        try {
            if (selectedCategory === "REPORT COOP") {
                await getRepoCoop(defaultDates.from, defaultDates.to, []);
                setSortConfig({ column: 'segreteria', direction: 'asc' });
            } else if (selectedCategory === "REPORT ODS") {
                await Promise.all([
                    fetchOdsFilterOptions(),
                    getRepoOds(defaultStatoErrore, defaultDates.from, defaultDates.to, [], [], [], [], false)
                ]);
                setSortConfig({ column: 'data', direction: 'desc' });
            } else if (selectedCategory === "REPORT ABITI") {
                setAbitiAggregation('giorno');
                await getRepoAbiti(defaultDates.from, defaultDates.to, 'giorno');
            }
        } catch (err) {
            console.error("Errore nella fetch:", err);
        } finally {
            setTableLoading(false);
        }
    };

    const handleFileChange = (type, file) => {
        setSelectedFiles((prev) => ({ ...prev, [type]: file }));
        setMessage({ type: "", text: "", category: "" });
        setAnagraficaErrors({ show: false, codici: [], category: "" });
        setColumnErrors({ show: false, columns: [], category: "" });
        setDuplicateErrors({ show: false, itinerari: [], category: "" });
    };

    const handleUpload = async (type) => {
        if (!selectedFiles[type]) {
            setMessage({ type: "error", text: "Seleziona un file prima di procedere", category: type });
            return;
        }

        setLoading((prev) => ({ ...prev, [type]: true }));
        setMessage({ type: "", text: "", category: "" });

        const formData = new FormData();
        formData.append("file", selectedFiles[type]);

        try {
            const response = await axios.post(`${API_URL}/hera/${type}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            setMessage({ type: "success", text: response.data.message || "File caricato con successo", category: type });
            setSelectedFiles((prev) => ({ ...prev, [type]: null }));

            const fileInput = document.querySelector(`#file-input-${type}`);
            if (fileInput) fileInput.value = "";

            await fetchLastUploads();
        } catch (error) {
            console.error("Errore durante l'upload:", error);

            // Gestione errori di colonne mancanti
            if (error.response?.data?.missingColumns && Array.isArray(error.response.data.missingColumns)) {
                setColumnErrors({
                    show: true,
                    columns: error.response.data.missingColumns,
                    category: type
                });
                setMessage({
                    type: "error",
                    text: error.response?.data?.error || "Colonne mancanti nel file",
                    category: type
                });
            }
            // Gestione errori di anagrafica con codici mancanti
            else if (error.response?.data?.codiciMancanti && Array.isArray(error.response.data.codiciMancanti)) {
                setAnagraficaErrors({
                    show: true,
                    codici: error.response.data.codiciMancanti,
                    category: type
                });
                setMessage({
                    type: "error",
                    text: error.response?.data?.error || "Errori di anagrafica rilevati",
                    category: type
                });
            }
            // Gestione errori di itinerari duplicati nel file
            else if (error.response?.data?.itinerariDuplicati && Array.isArray(error.response.data.itinerariDuplicati)) {
                setDuplicateErrors({
                    show: true,
                    itinerari: error.response.data.itinerariDuplicati,
                    category: type
                });
                setMessage({
                    type: "error",
                    text: error.response?.data?.error || "Il file contiene Itinerari duplicati",
                    category: type
                });
            } else {
                setMessage({
                    type: "error",
                    text: error.response?.data?.error || "Errore durante il caricamento del file",
                    category: type
                });
            }
        } finally {
            setLoading((prev) => ({ ...prev, [type]: false }));
        }
    };

    const handleDownloadFile = async () => {
        try {

            //creo una mappa dei titoli formattati per le colonne
            const columnTitles = {};
            for (let i = 0; i < colonne.length; i++) {
                const nomeColonna = colonne[i];
                const titoloAbbreviato = getColumnTitle(nomeColonna);
                columnTitles[nomeColonna] = titoloAbbreviato;
            }

            const response = await axios.post(`${API_URL}/hera/downloadReport`,
                { tableName: selectedCategory, datiDaStampare: filteredTableData, columnTitles: columnTitles },
                { responseType: "blob" }
            );

            if (response.data.type === "application/json") {
                const text = await response.data.text();
                const errorData = JSON.parse(text);
                throw new Error(errorData.error || "Errore durante il download");
            }

            // Estrai il nome del file dall'header Content-Disposition
            const contentDisposition = response.headers['content-disposition'];
            let fileName = `${selectedCategory}.xlsx`; // Default fallback

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1];
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Errore durante il download del file:", error);
            setMessage({
                type: "error",
                text: error.response?.data?.error || error.message || "Errore durante il download del file",
            });
        }
    };

    const handlePanelToggle = (type) => {
        if (type === "filters") {
            setShowFiltersPanel(!showFiltersPanel);
            setShowUploadPanel(false);
        } else if (type === "upload") {
            setShowUploadPanel(!showUploadPanel);
            setShowFiltersPanel(false);
        }
    };

    const handleColHover = (col, event) => {
        if (event) {
            const rect = event.currentTarget.getBoundingClientRect();
            setTooltipPosition({ x: rect.left + rect.width / 2, y: rect.top - 10 });
        }
        setHoveredCol(col);
    };

    const handleColLeave = () => {
        setHoveredCol(null);
    };

    const handleSort = (columnIndex) => {
        const column = colonne[columnIndex];
        let direction = 'asc';

        // Se è già ordinata per questa colonna, cambia direzione
        if (sortConfig.column === column) {
            if (sortConfig.direction === 'asc') {
                direction = 'desc';
            } else if (sortConfig.direction === 'desc') {
                // Reset dell'ordinamento
                setSortConfig({ column: null, direction: null });
                return;
            }
        }

        setSortConfig({ column, direction });
    };

    // Funzione per ottenere i dati ordinati
    const getSortedData = () => {
        if (!sortConfig.column || !sortConfig.direction) {
            return filteredTableData;
        }

        const sorted = [...filteredTableData].sort((a, b) => {
            const aValue = a[sortConfig.column];
            const bValue = b[sortConfig.column];

            // Gestione speciale per "X" e stringhe vuote
            const isAX = aValue === 'X';
            const isBX = bValue === 'X';
            const isAEmpty = aValue === '';
            const isBEmpty = bValue === '';

            // In ascendente: X va su (prima)
            if (sortConfig.direction === 'asc') {
                if (isAX && !isBX) return -1;
                if (!isAX && isBX) return 1;
            }

            // In descendente: "" va su (prima)
            if (sortConfig.direction === 'desc') {
                if (isAEmpty && !isBEmpty) return -1;
                if (!isAEmpty && isBEmpty) return 1;
            }

            // Gestione valori null/undefined
            if (aValue === null || aValue === undefined) return 1;
            if (bValue === null || bValue === undefined) return -1;

            // Controlla se entrambi i valori sono numerici
            const aNum = Number(aValue);
            const bNum = Number(bValue);
            const isANumber = !isNaN(aNum) && aValue !== '';
            const isBNumber = !isNaN(bNum) && bValue !== '';

            // Se entrambi sono numeri, ordina come numeri
            if (isANumber && isBNumber) {
                return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
            }

            // Altrimenti, ordina come stringhe
            const aStr = String(aValue).toLowerCase();
            const bStr = String(bValue).toLowerCase();

            if (aStr < bStr) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aStr > bStr) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });

        return sorted;
    };

    // ==================== REPORT ABITI HELPERS ====================

    const abitiStats = (() => {
        if (abitiData.length === 0) return { hera: 0, interacta: 0, entrambi: 0, concordanza: 0 };
        let totalHera = 0, totalInteracta = 0, totalEntrambi = 0;
        abitiData.forEach(d => {
            totalHera += d.hera || 0;
            totalInteracta += d.interacta || 0;
            totalEntrambi += d.entrambi || 0;
        });
        const concordanza = totalHera + totalInteracta > 0
            ? (totalEntrambi * 2 / (totalHera + totalInteracta) * 100)
            : 0;
        return { hera: totalHera, interacta: totalInteracta, entrambi: totalEntrambi, concordanza };
    })();

    const formatAbitiNumber = (n) => {
        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    // Parsa "YYYY-MM-DD" senza passare per Date (evita problemi timezone)
    const parseAbitiDateParts = (dateStr) => {
        if (!dateStr) return null;
        const parts = dateStr.split('-');
        return { year: parseInt(parts[0]), month: parseInt(parts[1]), day: parseInt(parts[2]) };
    };

    const formatAbitiDate = (dateStr) => {
        const p = parseAbitiDateParts(dateStr);
        if (!p) return '';
        return `${String(p.day).padStart(2, '0')}/${String(p.month).padStart(2, '0')}/${p.year}`;
    };

    const getAbitiChartLabel = (dateStr) => {
        const p = parseAbitiDateParts(dateStr);
        if (!p) return '';
        const monthNames = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
        if (abitiAggregation === 'mese') {
            return monthNames[p.month - 1] + ' ' + String(p.year).substring(2);
        } else if (abitiAggregation === 'anno') {
            return String(p.year);
        }
        return `${String(p.day).padStart(2, '0')}/${String(p.month).padStart(2, '0')}`;
    };

    const abitiSortedData = [...abitiData].sort((a, b) => new Date(b.data) - new Date(a.data));
    const abitiTotalPages = Math.max(1, Math.ceil(abitiSortedData.length / ABITI_PAGE_SIZE));
    const abitiPageData = abitiSortedData.slice(abitiPage * ABITI_PAGE_SIZE, (abitiPage + 1) * ABITI_PAGE_SIZE);

    const handleAbitiApply = async () => {
        setTableLoading(true);
        try {
            await getRepoAbiti(fromDate, toDate);
        } finally {
            setTableLoading(false);
        }
    };

    const handleAbitiReset = async () => {
        const defaultDates = getDefaultDateRange();
        setFromDate(defaultDates.from);
        setToDate(defaultDates.to);
        setAbitiAggregation('giorno');
        setTableLoading(true);
        try {
            await getRepoAbiti(defaultDates.from, defaultDates.to);
        } finally {
            setTableLoading(false);
        }
    };

    const handleOpenAbitiDetail = async (dateStr) => {
        setAbitiDetailModal({ show: true, date: dateStr, data: null, loading: true });
        setAbitiSelectedHera(null);
        setAbitiSelectedInteracta(null);
        const detail = await getRepoAbitiDetail(dateStr);
        setAbitiDetailModal({ show: true, date: dateStr, data: detail, loading: false });
    };

    const destroyAbitiMap = () => {
        if (abitiMapInstanceRef.current) {
            abitiMapInstanceRef.current.remove();
            abitiMapInstanceRef.current = null;
        }
        abitiMarkerHeraRef.current = null;
        abitiMarkerInteractaRef.current = null;
    };

    const handleCloseAbitiDetail = () => {
        setAbitiDetailModal({ show: false, date: null, data: null, loading: false });
        setAbitiSelectedHera(null);
        setAbitiSelectedInteracta(null);
        destroyAbitiMap();
    };

    const abitiHeraIcon = useRef(null);
    const abitiInteractaIcon = useRef(null);
    if (!abitiHeraIcon.current) {
        abitiHeraIcon.current = L.divIcon({
            className: '',
            html: '<div style="width:28px;height:28px;background:linear-gradient(135deg,#3B82F6,#2563EB);border:3px solid #fff;border-radius:50%;box-shadow:0 2px 8px rgba(59,130,246,0.5);"></div>',
            iconSize: [28, 28],
            iconAnchor: [14, 14],
            popupAnchor: [0, -16]
        });
    }
    if (!abitiInteractaIcon.current) {
        abitiInteractaIcon.current = L.divIcon({
            className: '',
            html: '<div style="width:28px;height:28px;background:linear-gradient(135deg,#10B981,#059669);border:3px solid #fff;border-radius:50%;box-shadow:0 2px 8px rgba(16,185,129,0.5);"></div>',
            iconSize: [28, 28],
            iconAnchor: [14, 14],
            popupAnchor: [0, -16]
        });
    }

    // Crea la mappa Leaflet sul container (lazy, idempotente)
    const ensureAbitiMap = () => {
        if (abitiMapInstanceRef.current) return abitiMapInstanceRef.current;
        const node = abitiMapRef.current;
        if (!node || node.offsetWidth === 0) return null;
        abitiMarkerHeraRef.current = null;
        abitiMarkerInteractaRef.current = null;
        const map = L.map(node).setView([44.494, 11.347], 10);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors',
            maxZoom: 19
        }).addTo(map);
        abitiMapInstanceRef.current = map;
        // invalidateSize ripetuti per garantire che le tiles si carichino correttamente
        setTimeout(() => map.invalidateSize(), 100);
        setTimeout(() => map.invalidateSize(), 300);
        setTimeout(() => map.invalidateSize(), 600);
        return map;
    };

    const fitAbitiMapBounds = useCallback(() => {
        const map = abitiMapInstanceRef.current;
        if (!map) return;
        map.invalidateSize();
        const markers = [abitiMarkerHeraRef.current, abitiMarkerInteractaRef.current].filter(Boolean);
        if (markers.length === 2) {
            const group = L.featureGroup(markers);
            map.fitBounds(group.getBounds().pad(0.3));
        } else if (markers.length === 1) {
            map.setView(markers[0].getLatLng(), 16);
        }
    }, []);

    // Piazza un marker sulla mappa dato lat/lon già noti
    const placeMarkerOnMap = (lat, lon, address, type) => {
        const markerRef = type === 'hera' ? abitiMarkerHeraRef : abitiMarkerInteractaRef;
        const icon = type === 'hera' ? abitiHeraIcon.current : abitiInteractaIcon.current;
        const setSelected = type === 'hera' ? setAbitiSelectedHera : setAbitiSelectedInteracta;

        const map = ensureAbitiMap();
        if (!map) {
            setSelected(prev => prev ? { ...prev, loading: false } : prev);
            return;
        }

        if (markerRef.current) {
            map.removeLayer(markerRef.current);
        }
        const label = type === 'hera' ? 'Hera' : 'Interacta';
        const color = type === 'hera' ? '#2563EB' : '#059669';
        markerRef.current = L.marker([lat, lon], { icon }).addTo(map);
        markerRef.current.bindPopup(`<strong style="color:${color}">[${label}]</strong><br/>${address}`);
        setSelected(prev => prev ? { ...prev, loading: false } : prev);

        const refreshMap = () => {
            map.invalidateSize();
            fitAbitiMapBounds();
            if (markerRef.current) markerRef.current.openPopup();
            if (abitiMapRef.current) {
                abitiMapRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        };
        setTimeout(refreshMap, 100);
        setTimeout(() => { map.invalidateSize(); fitAbitiMapBounds(); }, 300);
        setTimeout(() => { map.invalidateSize(); fitAbitiMapBounds(); }, 700);
    };

    // Per Hera: usa coordinate dirette; per Interacta: geocoding sull'indirizzo
    const geocodeAndPlaceMarker = (address, type, coords) => {
        const setSelected = type === 'hera' ? setAbitiSelectedHera : setAbitiSelectedInteracta;

        // Se abbiamo coordinate dirette (Hera), usale senza geocoding
        if (coords && coords.lat && coords.lon) {
            setTimeout(() => placeMarkerOnMap(coords.lat, coords.lon, address, type), 0);
            return;
        }

        // Altrimenti geocoding sull'indirizzo (Interacta)
        const query = address + ', Italia';
        axios.get(`${API_URL}/hera/geocode`, { params: { q: query } })
            .then(res => res.data)
            .then(data => {
                if (!data || data.length === 0) {
                    setSelected(prev => prev ? { ...prev, loading: false } : prev);
                    return;
                }
                const lat = parseFloat(data[0].lat);
                const lon = parseFloat(data[0].lon);
                placeMarkerOnMap(lat, lon, address, type);
            })
            .catch(() => {
                setSelected(prev => prev ? { ...prev, loading: false } : prev);
            });
    };

    const handleSelectAbitiAddress = (address, index, type, coords) => {
        const currentSelected = type === 'hera' ? abitiSelectedHera : abitiSelectedInteracta;
        const setSelected = type === 'hera' ? setAbitiSelectedHera : setAbitiSelectedInteracta;
        const markerRef = type === 'hera' ? abitiMarkerHeraRef : abitiMarkerInteractaRef;

        // If clicking the same already-selected item -> deselect
        if (currentSelected && currentSelected.index === index) {
            const otherSelected = type === 'hera' ? abitiSelectedInteracta : abitiSelectedHera;
            if (markerRef.current && abitiMapInstanceRef.current) {
                abitiMapInstanceRef.current.removeLayer(markerRef.current);
                markerRef.current = null;
            }
            setSelected(null);
            if (!otherSelected) {
                destroyAbitiMap();
            } else {
                setTimeout(fitAbitiMapBounds, 50);
            }
            return;
        }

        setSelected({ index, address, loading: true });
        setTimeout(() => geocodeAndPlaceMarker(address, type, coords), 0);
    };

    const handleRemoveAbitiMarker = (type) => {
        const markerRef = type === 'hera' ? abitiMarkerHeraRef : abitiMarkerInteractaRef;
        const setSelected = type === 'hera' ? setAbitiSelectedHera : setAbitiSelectedInteracta;
        const otherSelected = type === 'hera' ? abitiSelectedInteracta : abitiSelectedHera;
        if (markerRef.current && abitiMapInstanceRef.current) {
            abitiMapInstanceRef.current.removeLayer(markerRef.current);
            markerRef.current = null;
        }
        setSelected(null);
        // Se non resta nessun marker, distruggi la mappa (il div verrà smontato)
        if (!otherSelected) {
            destroyAbitiMap();
        } else {
            setTimeout(fitAbitiMapBounds, 50);
        }
    };


    const handleAbitiBarHover = (e, d) => {
        const container = e.currentTarget.closest('.abiti-chart-placeholder');
        if (!container) return;
        const rect = container.getBoundingClientRect();
        const evtRect = e.currentTarget.getBoundingClientRect();
        let left = evtRect.left - rect.left + evtRect.width / 2;
        let top = evtRect.top - rect.top - 10;
        if (left + 180 > rect.width) left = left - 180;
        if (top < 0) top = evtRect.bottom - rect.top + 5;
        setAbitiChartTooltip({ show: true, x: left, y: top, data: d });
    };

    // Aggrega i dati giornalieri per il grafico in base all'aggregazione scelta
    const getAbitiChartData = () => {
        if (abitiAggregation === 'giorno') {
            return abitiData.map(d => ({
                label: getAbitiChartLabel(d.data),
                hera: d.hera || 0,
                interacta: d.interacta || 0
            }));
        }
        const groups = {};
        abitiData.forEach(d => {
            const dt = new Date(d.data);
            const key = abitiAggregation === 'mese'
                ? `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`
                : `${dt.getFullYear()}`;
            if (!groups[key]) groups[key] = { hera: 0, interacta: 0, date: d.data };
            groups[key].hera += (d.hera || 0);
            groups[key].interacta += (d.interacta || 0);
        });
        return Object.keys(groups).sort().map(key => ({
            label: getAbitiChartLabel(groups[key].date),
            hera: groups[key].hera,
            interacta: groups[key].interacta
        }));
    };

    const renderAbitiChart = () => {
        const chartData = getAbitiChartData();

        if (chartData.length === 0) return null;

        const n = chartData.length;
        const isDaily = abitiAggregation === 'giorno';
        const needsRotation = isDaily && n > 10;

        const svgWidth = 900;
        const marginLeft = 45;
        const marginRight = 15;
        const marginTop = 16;
        const marginBottom = needsRotation ? 65 : 32;
        const svgHeight = 180 + marginBottom;
        const chartWidth = svgWidth - marginLeft - marginRight;
        const chartHeight = svgHeight - marginTop - marginBottom;

        let maxVal = 0;
        chartData.forEach(d => {
            if (d.hera > maxVal) maxVal = d.hera;
            if (d.interacta > maxVal) maxVal = d.interacta;
        });
        maxVal = Math.ceil(maxVal / 50) * 50;
        if (maxVal === 0) maxVal = 100;

        const groupWidth = chartWidth / n;
        const barPadding = Math.max(2, groupWidth * 0.15);
        const barAreaWidth = groupWidth - barPadding * 2;
        let singleBarWidth = barAreaWidth / 2 - 1;
        if (singleBarWidth < 2) singleBarWidth = 2;
        if (singleBarWidth > 30) singleBarWidth = 30;

        const labelRotation = needsRotation ? -45 : 0;
        const gridSteps = 4;

        return (
            <svg className="abiti-bar-chart" viewBox={`0 0 ${svgWidth} ${svgHeight}`} preserveAspectRatio="xMidYMid meet">
                <defs>
                    <linearGradient id="barGradBlue" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#3B82F6" />
                        <stop offset="100%" stopColor="#2E6DB1" />
                    </linearGradient>
                    <linearGradient id="barGradGreen" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#10B981" />
                        <stop offset="100%" stopColor="#059669" />
                    </linearGradient>
                </defs>

                {/* Grid lines & Y labels */}
                {Array.from({ length: gridSteps + 1 }, (_, i) => {
                    const gy = marginTop + (chartHeight / gridSteps) * i;
                    const labelVal = Math.round(maxVal - (maxVal / gridSteps) * i);
                    return (
                        <g key={`grid-${i}`}>
                            <line className="grid-line" x1={marginLeft} y1={gy} x2={svgWidth - marginRight} y2={gy} />
                            <text className="axis-label" x={marginLeft - 6} y={gy + 4} textAnchor="end">{labelVal}</text>
                        </g>
                    );
                })}

                {/* Axes */}
                <line className="axis-line" x1={marginLeft} y1={marginTop + chartHeight} x2={svgWidth - marginRight} y2={marginTop + chartHeight} />
                <line className="axis-line" x1={marginLeft} y1={marginTop} x2={marginLeft} y2={marginTop + chartHeight} />

                {/* Bars */}
                {chartData.map((d, i) => {
                    const groupX = marginLeft + i * groupWidth;
                    const centerX = groupX + groupWidth / 2;
                    const barStartX = centerX - singleBarWidth - 0.5;

                    const heraH = (d.hera / maxVal) * chartHeight;
                    const heraY = marginTop + chartHeight - heraH;

                    const intH = (d.interacta / maxVal) * chartHeight;
                    const intY = marginTop + chartHeight - intH;

                    const fontSize = n > 20 ? 7 : n > 10 ? 8 : 9;

                    return (
                        <g key={`bar-${i}`}>
                            <rect
                                className="bar"
                                x={barStartX}
                                y={heraY}
                                width={singleBarWidth}
                                height={Math.max(0, heraH)}
                                rx={2}
                                fill="url(#barGradBlue)"
                                onMouseEnter={(e) => handleAbitiBarHover(e, d)}
                                onMouseLeave={() => setAbitiChartTooltip({ show: false, x: 0, y: 0, data: null })}
                            />
                            <rect
                                className="bar"
                                x={centerX + 0.5}
                                y={intY}
                                width={singleBarWidth}
                                height={Math.max(0, intH)}
                                rx={2}
                                fill="url(#barGradGreen)"
                                onMouseEnter={(e) => handleAbitiBarHover(e, d)}
                                onMouseLeave={() => setAbitiChartTooltip({ show: false, x: 0, y: 0, data: null })}
                            />
                            <text
                                className="axis-label"
                                x={centerX}
                                y={marginTop + chartHeight + 16}
                                textAnchor={labelRotation !== 0 ? 'end' : 'middle'}
                                transform={labelRotation !== 0 ? `rotate(${labelRotation},${centerX},${marginTop + chartHeight + 16})` : undefined}
                                fontSize={fontSize}
                            >
                                {d.label}
                            </text>
                        </g>
                    );
                })}
            </svg>
        );
    };

    // ==================== END REPORT ABITI HELPERS ====================

    return (
        <div className="hera-page">
            {/* Header */}
            <header className="hera-header">
                <div className="hera-header-content">
                    <button className="hera-back-btn" onClick={() => navigate('/automazione')}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Indietro
                    </button>

                    <div className="hera-header-title">
                        <div className="hera-title-row">
                            <h1>Report Hera</h1>
                            <button className="hera-info-btn" onClick={() => setShowInfoModal(true)} title="Informazioni">
                                <span>i</span>
                            </button>
                        </div>
                        <p className="hera-subtitle">Gestione report e caricamento file per Hera</p>
                    </div>
                </div>
            </header>

            {/* Modal Info */}
            {showInfoModal && (
                <div className="hera-modal-overlay" onClick={() => setShowInfoModal(false)}>
                    <div className="hera-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="hera-modal-header">
                            <div className="hera-modal-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>
                            </div>
                            <h3>Informazioni sulla pagina</h3>
                            <button className="hera-modal-close" onClick={() => setShowInfoModal(false)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                        <div className="hera-modal-body">
                            {selectedCategory === "REPORT ABITI" ? (<>
                                <div className="hera-modal-section">
                                    <h4>Cosa fa questa sezione?</h4>
                                    <p>
                                        Confronta i dati di raccolta abiti tra il sistema Hera e Interacta,
                                        evidenziando le discrepanze giornaliere tramite grafici e tabelle dettagliate.
                                    </p>
                                </div>
                                <div className="hera-modal-section">
                                    <h4>Come utilizzarla?</h4>
                                    <ul>
                                        <li><strong>Filtri data:</strong> Seleziona il periodo di interesse tramite le date in alto</li>
                                        <li><strong>Aggregazione:</strong> Scegli la vista per giorno, settimana o mese</li>
                                        <li><strong>Grafico:</strong> Visualizza il confronto Hera vs Interacta nel tempo</li>
                                        <li><strong>Dettaglio:</strong> Clicca su una riga della tabella per aprire il confronto indirizzi</li>
                                        <li><strong>Mappa:</strong> Nel dettaglio, clicca su un indirizzo per visualizzarlo sulla mappa e confrontare le posizioni</li>
                                    </ul>
                                </div>
                            </>) : (<>
                                <div className="hera-modal-section">
                                    <h4>Cosa fa questa pagina?</h4>
                                    <p>
                                        Questa pagina permette di gestire i report Hera, caricare file Excel
                                        e visualizzare i dati in formato tabellare con possibilità di filtraggio
                                        e download.
                                    </p>
                                </div>
                                <div className="hera-modal-section">
                                    <h4>Come utilizzarla?</h4>
                                    <ul>
                                        <li><strong>Carica File:</strong> Utilizza il pannello upload per caricare nuovi file Excel</li>
                                        <li><strong>Filtri:</strong> Applica filtri per data e segreteria</li>
                                        <li><strong>Categorie:</strong> Seleziona il tipo di report da visualizzare</li>
                                        <li><strong>Download:</strong> Esporta i dati filtrati in formato Excel</li>
                                    </ul>
                                </div>
                            </>)}
                        </div>
                    </div>
                </div>
            )}

            {/* Main Content */}
            <main className="hera-main">
                {/* Action Buttons - hidden on REPORT ABITI */}
                {selectedCategory !== "REPORT ABITI" && <div className="hera-actions">
                    <button
                        className={`hera-action-btn ${showFiltersPanel ? 'active' : ''}`}
                        onClick={() => handlePanelToggle("filters")}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                        </svg>
                        <span>{showFiltersPanel ? 'Nascondi Filtri' : 'Mostra Filtri'}</span>
                    </button>

                    <button
                        className={`hera-action-btn ${showUploadPanel ? 'active' : ''}`}
                        onClick={() => handlePanelToggle("upload")}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="17 8 12 3 7 8"></polyline>
                            <line x1="12" y1="3" x2="12" y2="15"></line>
                        </svg>
                        <span>Carica File</span>
                    </button>
                </div>}

                {/* Filters Panel - hidden on REPORT ABITI */}
                {selectedCategory !== "REPORT ABITI" && (<>

                    {/* Filters Panel */}
                    {showFiltersPanel && (
                        <div className="hera-panel">
                            <form className="hera-filters-form" onSubmit={handleFilterSubmit}>
                                <div className="hera-filters-grid">
                                    <div className="hera-filter-item">
                                        <label>Data Inizio</label>
                                        <DatePickerModal
                                            value={fromDate}
                                            onChange={(e) => setFromDate(e.target.value)}
                                            max={toDate || undefined}
                                            label="Data Inizio"
                                        />
                                    </div>

                                    <div className="hera-filter-item">
                                        <label>Data Fine</label>
                                        <DatePickerModal
                                            value={toDate}
                                            onChange={(e) => setToDate(e.target.value)}
                                            min={fromDate || undefined}
                                            label="Data Fine"
                                        />
                                    </div>

                                    <div className="hera-filter-item hera-filter-wide">
                                        <label>Segreteria</label>
                                        <Select
                                            isMulti
                                            classNamePrefix="hera-select"
                                            placeholder="Seleziona segreteria..."
                                            value={listaSegreteria
                                                .filter(item => selectedSegreteria.includes(item.segreteria))
                                                .map(item => ({ value: item.segreteria, label: item.segreteria }))}
                                            options={listaSegreteria.map(item => ({
                                                value: item.segreteria,
                                                label: item.segreteria
                                            }))}
                                            onChange={(selectedValue) => setSelectedSegreteria(selectedValue.map((s) => s.value))}
                                        />
                                    </div>

                                    {selectedCategory === "REPORT ODS" && (
                                        <>
                                            <div className="hera-filter-item hera-filter-wide">
                                                <label>ODS</label>
                                                <Select
                                                    isMulti
                                                    classNamePrefix="hera-select"
                                                    placeholder="Cerca ODS..."
                                                    isSearchable
                                                    value={odsFilterOptions.servizi
                                                        .filter(s => selectedServizi.includes(s))
                                                        .map(s => ({ value: s, label: s }))}
                                                    options={odsFilterOptions.servizi.map(s => ({ value: s, label: s }))}
                                                    onChange={(selectedValue) => setSelectedServizi(selectedValue ? selectedValue.map((s) => s.value) : [])}
                                                    noOptionsMessage={() => "Nessun ODS trovato"}
                                                />
                                            </div>
                                            <div className="hera-filter-item hera-filter-wide">
                                                <label>Codice Itinerario</label>
                                                <Select
                                                    isMulti
                                                    classNamePrefix="hera-select"
                                                    placeholder="Cerca itinerario..."
                                                    isSearchable
                                                    value={odsFilterOptions.codiciItinerario
                                                        .filter(c => selectedCodiciItinerario.includes(c))
                                                        .map(c => ({ value: c, label: c }))}
                                                    options={odsFilterOptions.codiciItinerario.map(c => ({ value: c, label: c }))}
                                                    onChange={(selectedValue) => setSelectedCodiciItinerario(selectedValue ? selectedValue.map((s) => s.value) : [])}
                                                    noOptionsMessage={() => "Nessun itinerario trovato"}
                                                />
                                            </div>
                                            <div className="hera-filter-item hera-filter-wide">
                                                <label>Tipo Errore</label>
                                                <Select
                                                    isMulti
                                                    classNamePrefix="hera-select"
                                                    placeholder="Seleziona tipo errore..."
                                                    isSearchable
                                                    value={odsFilterOptions.tipiErrore
                                                        .filter(t => selectedTipiErrore.includes(t))
                                                        .map(t => ({ value: t, label: getColumnTitle(t) }))}
                                                    options={odsFilterOptions.tipiErrore.map(t => ({ value: t, label: getColumnTitle(t) }))}
                                                    onChange={(selectedValue) => setSelectedTipiErrore(selectedValue ? selectedValue.map((s) => s.value) : [])}
                                                    noOptionsMessage={() => "Nessun tipo errore trovato"}
                                                />
                                            </div>
                                            <div className="hera-filter-item hera-filter-wide">
                                                <label>Stato Errore</label>
                                                <Select
                                                    isMulti
                                                    classNamePrefix="hera-select"
                                                    placeholder="Seleziona stato errore..."
                                                    value={statoErroreOptions.filter(opt => selectedStatoErrore.includes(opt.value))}
                                                    options={statoErroreOptions}
                                                    onChange={(selectedValue) => setSelectedStatoErrore(selectedValue.map((s) => s.value))}
                                                />
                                            </div>
                                            <div className="hera-filter-item">
                                                <label>Ignora</label>
                                                <Select
                                                    classNamePrefix="hera-select"
                                                    placeholder="Filtra per ignora..."
                                                    isClearable
                                                    value={ignoraOptions.find(opt => opt.value === selectedIgnora) || null}
                                                    options={ignoraOptions}
                                                    onChange={(selectedValue) => setSelectedIgnora(selectedValue ? selectedValue.value : null)}
                                                />
                                            </div>
                                        </>
                                    )}

                                    <div className="hera-filter-actions">
                                        <button type="submit" className="hera-btn-primary">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                            Applica
                                        </button>
                                        <button type="button" className="hera-btn-secondary" onClick={handleReset}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                                                <path d="M3 3v5h5"></path>
                                            </svg>
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* Upload Panel */}
                    {showUploadPanel && (
                        <div className="hera-panel">
                            <div className="hera-upload-grid">
                                {uploadTypes.map((type) => (
                                    <div className="hera-upload-card" key={type.key}>
                                        <div className="hera-upload-card-icon">
                                            {type.icon}
                                        </div>
                                        <div className="hera-upload-card-header">
                                            <h3>{type.title}</h3>
                                            <p>{type.description}</p>
                                        </div>

                                        <div className="hera-upload-card-body">
                                            <div className="hera-file-input-wrapper">
                                                <label htmlFor={`file-input-${type.key}`} className="hera-file-label">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                                        <polyline points="17 8 12 3 7 8"></polyline>
                                                        <line x1="12" y1="3" x2="12" y2="15"></line>
                                                    </svg>
                                                    <span>
                                                        {selectedFiles[type.key]
                                                            ? selectedFiles[type.key].name
                                                            : "Seleziona file Excel"}
                                                    </span>
                                                </label>
                                                <input
                                                    id={`file-input-${type.key}`}
                                                    type="file"
                                                    accept=".xlsx,.xls,.csv"
                                                    onChange={(e) => handleFileChange(type.key, e.target.files[0])}
                                                    className="hera-file-input"
                                                />
                                            </div>

                                            <button
                                                className="hera-btn-upload"
                                                onClick={() => handleUpload(type.key)}
                                                disabled={loading[type.key] || !selectedFiles[type.key]}
                                            >
                                                {loading[type.key] ? (
                                                    <>
                                                        <div className="hera-spinner"></div>
                                                        Caricamento...
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                                            <polyline points="17 8 12 3 7 8"></polyline>
                                                            <line x1="12" y1="3" x2="12" y2="15"></line>
                                                        </svg>
                                                        Carica
                                                    </>
                                                )}
                                            </button>

                                            {message.category === type.key && (
                                                <div className={`hera-message ${message.type}`}>
                                                    {message.type === "success" ? (
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                            <polyline points="22,4 12,14.01 9,11.01" />
                                                        </svg>
                                                    ) : (
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <circle cx="12" cy="12" r="10" />
                                                            <line x1="15" y1="9" x2="9" y2="15" />
                                                            <line x1="9" y1="9" x2="15" y2="15" />
                                                        </svg>
                                                    )}
                                                    <span>{message.text}</span>
                                                </div>
                                            )}

                                            {columnErrors.show && columnErrors.category === type.key && (
                                                <div className="hera-message-errors">
                                                    <div className="hera-message-errors-header">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <circle cx="12" cy="12" r="10"></circle>
                                                            <line x1="15" y1="9" x2="9" y2="15"></line>
                                                            <line x1="9" y1="9" x2="15" y2="15"></line>
                                                        </svg>
                                                        <span>Colonne Mancanti ({columnErrors.columns.length})</span>
                                                        <button
                                                            className="hera-message-errors-close"
                                                            onClick={() => setColumnErrors({ show: false, columns: [], category: "" })}
                                                            title="Chiudi"
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <div className="hera-message-errors-list">
                                                        {columnErrors.columns.map((column, index) => (
                                                            <div key={index} className="hera-message-error-item">
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                                                                    <line x1="12" y1="9" x2="12" y2="13"></line>
                                                                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                                                </svg>
                                                                <span>{column}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {anagraficaErrors.show && anagraficaErrors.category === type.key && (
                                                <div className="hera-message-errors">
                                                    <div className="hera-message-errors-header">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                                                            <line x1="12" y1="9" x2="12" y2="13"></line>
                                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                                        </svg>
                                                        <span>Codici Itinerari Mancanti ({anagraficaErrors.codici.length})</span>
                                                        <button
                                                            className="hera-message-errors-close"
                                                            onClick={() => setAnagraficaErrors({ show: false, codici: [], category: "" })}
                                                            title="Chiudi"
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <div className="hera-message-errors-list">
                                                        {anagraficaErrors.codici.map((codice, index) => (
                                                            <div key={index} className="hera-message-error-item">
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                    <circle cx="12" cy="12" r="10"></circle>
                                                                    <line x1="15" y1="9" x2="9" y2="15"></line>
                                                                    <line x1="9" y1="9" x2="15" y2="15"></line>
                                                                </svg>
                                                                <span>{codice}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {duplicateErrors.show && duplicateErrors.category === type.key && (
                                                <div className="hera-message-errors">
                                                    <div className="hera-message-errors-header">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                                                            <line x1="12" y1="9" x2="12" y2="13"></line>
                                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                                        </svg>
                                                        <span>Itinerari Duplicati nel File ({duplicateErrors.itinerari.length})</span>
                                                        <button
                                                            className="hera-message-errors-close"
                                                            onClick={() => setDuplicateErrors({ show: false, itinerari: [], category: "" })}
                                                            title="Chiudi"
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <div className="hera-message-errors-list">
                                                        {duplicateErrors.itinerari.map((itinerario, index) => (
                                                            <div key={index} className="hera-message-error-item">
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                    <circle cx="12" cy="12" r="10"></circle>
                                                                    <line x1="15" y1="9" x2="9" y2="15"></line>
                                                                    <line x1="9" y1="9" x2="15" y2="15"></line>
                                                                </svg>
                                                                <span>{itinerario}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {lastUploads[type.key] && (
                                                <div className="hera-upload-info">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <polyline points="12 6 12 12 16 14"></polyline>
                                                    </svg>
                                                    <span>Ultimo: {lastUploads[type.key]}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                </>)}

                {/* Data Section */}
                <div className="hera-data-section">
                    {initialLoading ? (
                        <Lf23Loader />
                    ) : (
                        <>
                            <div className="hera-data-header">
                                <FiltroCategorie categories={MOCKED_HERA_CATEGORIES} filteredCategory={handleCategorySelect} customCss={"automazione-section"} />

                            </div>

                            {/* REPORT ABITI Content */}
                            {selectedCategory === "REPORT ABITI" && (
                                tableLoading ? (
                                    <Lf23Loader />
                                ) : (
                                    <>
                                        {/* Filters Toggle */}
                                        <div className="abiti-top-controls">
                                            <div>
                                                <button
                                                    className={`abiti-toggle-filters-btn ${abitiFiltersVisible ? 'active' : ''}`}
                                                    onClick={() => setAbitiFiltersVisible(!abitiFiltersVisible)}
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                                                    </svg>
                                                    Filtri
                                                    <span className="chevron">{'\u25BC'}</span>
                                                </button>
                                            </div>
                                        </div>

                                        {/* Filters Panel */}
                                        {abitiFiltersVisible && (
                                            <div className="abiti-filters-panel">
                                                <div className="abiti-filters-grid">
                                                    <div className="abiti-filter-item">
                                                        <label className="abiti-filter-label">Data dal</label>
                                                        <DatePickerModal
                                                            value={fromDate}
                                                            onChange={(e) => setFromDate(e.target.value)}
                                                            max={toDate || undefined}
                                                            label="Data dal"
                                                            className="abiti-filter-input"
                                                        />
                                                    </div>
                                                    <div className="abiti-filter-item">
                                                        <label className="abiti-filter-label">Data al</label>
                                                        <DatePickerModal
                                                            value={toDate}
                                                            onChange={(e) => setToDate(e.target.value)}
                                                            min={fromDate || undefined}
                                                            label="Data al"
                                                            className="abiti-filter-input"
                                                        />
                                                    </div>
                                                    <div className="abiti-filter-actions">
                                                        <button type="button" className="abiti-btn-apply" onClick={handleAbitiApply}>Applica</button>
                                                        <button type="button" className="abiti-btn-reset" onClick={handleAbitiReset}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Stat Cards */}
                                        <div className="abiti-stats-grid">
                                            <div className="abiti-stat-card blue">
                                                <div className="abiti-stat-icon">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
                                                    </svg>
                                                </div>
                                                <div className="abiti-stat-info">
                                                    <span className="abiti-stat-value">{formatAbitiNumber(abitiStats.hera)}</span>
                                                    <span className="abiti-stat-label">Svuotamenti Hera</span>
                                                </div>
                                            </div>
                                            <div className="abiti-stat-card green">
                                                <div className="abiti-stat-icon">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" ry="1" /><path d="M9 14l2 2 4-4" />
                                                    </svg>
                                                </div>
                                                <div className="abiti-stat-info">
                                                    <span className="abiti-stat-value">{formatAbitiNumber(abitiStats.interacta)}</span>
                                                    <span className="abiti-stat-label">Svuotamenti Interacta</span>
                                                </div>
                                            </div>
                                            <div className="abiti-stat-card amber">
                                                <div className="abiti-stat-icon">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <polyline points="20 6 9 17 4 12" />
                                                    </svg>
                                                </div>
                                                <div className="abiti-stat-info">
                                                    <span className="abiti-stat-value">{formatAbitiNumber(abitiStats.entrambi)}</span>
                                                    <span className="abiti-stat-label">Tags Concordanti</span>
                                                </div>
                                            </div>
                                            <div className="abiti-stat-card purple">
                                                <div className="abiti-stat-icon">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <line x1="19" y1="5" x2="5" y2="19" /><circle cx="6.5" cy="6.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" />
                                                    </svg>
                                                </div>
                                                <div className="abiti-stat-info">
                                                    <span className="abiti-stat-value">{abitiStats.concordanza.toFixed(1).replace('.', ',')}%</span>
                                                    <span className="abiti-stat-label">Concordanza</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Chart */}
                                        <div className={`abiti-chart-section${isFullscreenAbitiChart ? ' fullscreen-hera' : ''}`}>
                                            <RotateDevice active={isFullscreenAbitiChart} />
                                            <div className="abiti-chart-header">
                                                <span className="abiti-chart-title">Svuotamenti Hera vs Interacta</span>
                                                <div className="abiti-chart-header-right">
                                                    <div className="abiti-granularity-buttons">
                                                        {['giorno', 'mese', 'anno'].map(agg => (
                                                            <button
                                                                key={agg}
                                                                type="button"
                                                                className={abitiAggregation === agg ? 'active' : ''}
                                                                onClick={() => setAbitiAggregation(agg)}
                                                            >
                                                                {agg.charAt(0).toUpperCase() + agg.slice(1)}
                                                            </button>
                                                        ))}
                                                    </div>
                                                    <div className="abiti-chart-legend">
                                                        <span className="abiti-chart-legend-item">
                                                            <span className="abiti-chart-legend-dot" style={{ background: 'linear-gradient(135deg, #3B82F6, #2E6DB1)' }}></span>
                                                            Hera
                                                        </span>
                                                        <span className="abiti-chart-legend-item">
                                                            <span className="abiti-chart-legend-dot" style={{ background: 'linear-gradient(135deg, #10B981, #059669)' }}></span>
                                                            Interacta
                                                        </span>
                                                    </div>
                                                    <button
                                                        className="hera-fullscreen-btn"
                                                        onClick={() => setIsFullscreenAbitiChart(!isFullscreenAbitiChart)}
                                                        title={isFullscreenAbitiChart ? 'Esci da tutto schermo' : 'Tutto schermo'}
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            {isFullscreenAbitiChart ? (
                                                                <><polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line></>
                                                            ) : (
                                                                <><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></>
                                                            )}
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="abiti-chart-body">
                                                <div className="abiti-chart-placeholder">
                                                    {renderAbitiChart()}
                                                    {abitiChartTooltip.show && abitiChartTooltip.data && (
                                                        <div
                                                            className="abiti-chart-tooltip"
                                                            style={{ display: 'block', left: `${abitiChartTooltip.x}px`, top: `${abitiChartTooltip.y}px` }}
                                                        >
                                                            <div className="tooltip-title">{abitiChartTooltip.data.label}</div>
                                                            <div className="tooltip-row">
                                                                <span className="tooltip-dot" style={{ background: '#3B82F6' }}></span>
                                                                Hera: <span className="tooltip-value">{formatAbitiNumber(abitiChartTooltip.data.hera)}</span>
                                                            </div>
                                                            <div className="tooltip-row">
                                                                <span className="tooltip-dot" style={{ background: '#10B981' }}></span>
                                                                Interacta: <span className="tooltip-value">{formatAbitiNumber(abitiChartTooltip.data.interacta)}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Table */}
                                        <div className={`abiti-table-container${isFullscreenAbitiTable ? ' fullscreen-hera' : ''}`}>
                                            <RotateDevice active={isFullscreenAbitiTable} />
                                            <div className="abiti-table-header-row">
                                                <span className="abiti-table-title">Dettaglio Svuotamenti</span>
                                                <button
                                                    className="hera-fullscreen-btn"
                                                    onClick={() => setIsFullscreenAbitiTable(!isFullscreenAbitiTable)}
                                                    title={isFullscreenAbitiTable ? 'Esci da tutto schermo' : 'Tutto schermo'}
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        {isFullscreenAbitiTable ? (
                                                            <><polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line></>
                                                        ) : (
                                                            <><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></>
                                                        )}
                                                    </svg>
                                                </button>
                                            </div>
                                            <div className="abiti-table-scroll">
                                                <table className="abiti-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Data</th>
                                                            <th className="abiti-text-right">Svuot. Hera</th>
                                                            <th className="abiti-text-right">Svuot. Interacta</th>
                                                            <th className="abiti-text-right">Solo Hera</th>
                                                            <th className="abiti-text-right">Solo Interacta</th>
                                                            <th className="abiti-text-right">Entrambi</th>
                                                            <th className="abiti-text-center">Dettaglio</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {abitiPageData.length > 0 ? abitiPageData.map((row, idx) => (
                                                            <tr key={idx}>
                                                                <td className="abiti-font-mono">{formatAbitiDate(row.data)}</td>
                                                                <td className="abiti-text-right abiti-font-mono">{formatAbitiNumber(row.hera)}</td>
                                                                <td className="abiti-text-right abiti-font-mono">{formatAbitiNumber(row.interacta)}</td>
                                                                <td className="abiti-text-right"><span className="abiti-badge abiti-badge-blue">{formatAbitiNumber(row.solo_hera)}</span></td>
                                                                <td className="abiti-text-right"><span className="abiti-badge abiti-badge-green">{formatAbitiNumber(row.solo_interacta)}</span></td>
                                                                <td className="abiti-text-right"><span className="abiti-badge abiti-badge-amber">{formatAbitiNumber(row.entrambi)}</span></td>
                                                                <td className="abiti-text-center">
                                                                    <button
                                                                        className="abiti-detail-btn"
                                                                        onClick={() => handleOpenAbitiDetail(row.data.split('T')[0])}
                                                                        title="Vedi dettaglio"
                                                                    >
                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                            <path d="M5 12h14" /><path d="M12 5l7 7-7 7" />
                                                                        </svg>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )) : (
                                                            <tr>
                                                                <td colSpan={7} style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>
                                                                    Nessun dato trovato nel periodo selezionato.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Pagination */}
                                        {abitiSortedData.length > ABITI_PAGE_SIZE && (
                                            <div className="abiti-pagination">
                                                <button
                                                    disabled={abitiPage === 0}
                                                    onClick={() => setAbitiPage(p => p - 1)}
                                                >
                                                    {'\u2190'} Precedente
                                                </button>
                                                <div className="abiti-page-info">
                                                    Pagina <strong>{abitiPage + 1}</strong> di <strong>{abitiTotalPages}</strong>
                                                    <br /><span style={{ fontSize: '11px', color: '#94a3b8' }}>Totale: {abitiSortedData.length} righe</span>
                                                </div>
                                                <button
                                                    disabled={abitiPage >= abitiTotalPages - 1}
                                                    onClick={() => setAbitiPage(p => p + 1)}
                                                >
                                                    Successiva {'\u2192'}
                                                </button>
                                            </div>
                                        )}

                                        {/* Detail Modal */}
                                        {abitiDetailModal.show && (
                                            <div className="abiti-modal-overlay" onClick={handleCloseAbitiDetail}>
                                                <div className="abiti-modal-container" onClick={(e) => e.stopPropagation()}>
                                                    <div className="abiti-modal-header">
                                                        <h3>Dettaglio - {formatAbitiDate(abitiDetailModal.date)}</h3>
                                                        <button className="abiti-modal-close" onClick={handleCloseAbitiDetail}>{'\u2715'}</button>
                                                    </div>
                                                    <div className="abiti-modal-body">
                                                        {abitiDetailModal.loading ? (
                                                            <Lf23Loader testo="Caricamento dettaglio..." />
                                                        ) : abitiDetailModal.data ? (
                                                            <>
                                                                {/* Solo Hera Section */}
                                                                <div className="abiti-detail-section hera">
                                                                    <div className="abiti-detail-section-header">
                                                                        <div className="abiti-detail-section-dot hera"></div>
                                                                        <span className="abiti-detail-section-title">Solo Hera</span>
                                                                        <span className="abiti-count-badge hera">{abitiDetailModal.data.tagsH.length}</span>
                                                                    </div>
                                                                    <div className="abiti-detail-rows">
                                                                        {abitiDetailModal.data.tagsH.length > 0 ? abitiDetailModal.data.tagsH
                                                                            .map((tag, i) => ({ tag, ind: abitiDetailModal.data.indH[i], coord: abitiDetailModal.data.coordH[i], orig: i }))
                                                                            .sort((a, b) => (a.ind || '').localeCompare(b.ind || ''))
                                                                            .map(({ tag, ind, coord, orig }) => (
                                                                                <div
                                                                                    key={orig}
                                                                                    className={`abiti-detail-row ${abitiSelectedHera && abitiSelectedHera.index === orig ? 'active' : ''}`}
                                                                                    onClick={() => (coord || ind) && handleSelectAbitiAddress(ind || '', orig, 'hera', coord)}
                                                                                >
                                                                                    <span className="abiti-detail-row-tag">
                                                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>
                                                                                        {tag}
                                                                                    </span>
                                                                                    <span className="abiti-detail-row-addr">
                                                                                        {ind ? (
                                                                                            <>
                                                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                                                                                                {ind}
                                                                                            </>
                                                                                        ) : (
                                                                                            <span className="abiti-detail-no-addr">Nessun indirizzo</span>
                                                                                        )}
                                                                                    </span>
                                                                                    {abitiSelectedHera && abitiSelectedHera.index === orig && (
                                                                                        <span className="abiti-detail-row-check hera">
                                                                                            {abitiSelectedHera.loading ? (
                                                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" className="abiti-spinner"><circle cx="12" cy="12" r="10" /></svg>
                                                                                            ) : (
                                                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                                                                                            )}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            )) : (
                                                                            <div className="abiti-detail-empty">Nessun dato solo Hera</div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Solo Interacta Section */}
                                                                <div className="abiti-detail-section interacta">
                                                                    <div className="abiti-detail-section-header">
                                                                        <div className="abiti-detail-section-dot interacta"></div>
                                                                        <span className="abiti-detail-section-title">Solo Interacta</span>
                                                                        <span className="abiti-count-badge interacta">{abitiDetailModal.data.tagsI.length}</span>
                                                                    </div>
                                                                    <div className="abiti-detail-rows">
                                                                        {abitiDetailModal.data.tagsI.length > 0 ? abitiDetailModal.data.tagsI
                                                                            .map((tag, i) => ({ tag, ind: abitiDetailModal.data.indI[i], coord: abitiDetailModal.data.coordI[i], orig: i }))
                                                                            .sort((a, b) => (a.ind || '').localeCompare(b.ind || ''))
                                                                            .map(({ tag, ind, coord, orig }) => (
                                                                                <div
                                                                                    key={orig}
                                                                                    className={`abiti-detail-row ${abitiSelectedInteracta && abitiSelectedInteracta.index === orig ? 'active' : ''}`}
                                                                                    onClick={() => (coord || ind) && handleSelectAbitiAddress(ind || '', orig, 'interacta', coord)}
                                                                                >
                                                                                    <span className="abiti-detail-row-tag">
                                                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>
                                                                                        {tag}
                                                                                    </span>
                                                                                    <span className="abiti-detail-row-addr">
                                                                                        {ind ? (
                                                                                            <>
                                                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                                                                                                {ind}
                                                                                            </>
                                                                                        ) : (
                                                                                            <span className="abiti-detail-no-addr">Nessun indirizzo</span>
                                                                                        )}
                                                                                    </span>
                                                                                    {abitiSelectedInteracta && abitiSelectedInteracta.index === orig && (
                                                                                        <span className="abiti-detail-row-check interacta">
                                                                                            {abitiSelectedInteracta.loading ? (
                                                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" className="abiti-spinner"><circle cx="12" cy="12" r="10" /></svg>
                                                                                            ) : (
                                                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                                                                                            )}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            )) : (
                                                                            <div className="abiti-detail-empty">Nessun dato solo Interacta</div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Hint mappa - visibile quando nessun indirizzo è selezionato */}
                                                                {!abitiSelectedHera && !abitiSelectedInteracta && (
                                                                    <div className="abiti-map-hint">
                                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="1.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                                                                        <span>Clicca su un indirizzo per visualizzarlo sulla mappa</span>
                                                                    </div>
                                                                )}

                                                                {/* Map - sempre nel DOM, nascosta con display quando nessun indirizzo selezionato */}
                                                                <div style={{ display: (abitiSelectedHera || abitiSelectedInteracta) ? undefined : 'none' }}>
                                                                    <div className="abiti-map-section-title">Mappa</div>
                                                                    <div className="abiti-map-container">
                                                                        <div className="abiti-map-controls">
                                                                            <div className="abiti-map-markers-info">
                                                                                {abitiSelectedHera && (
                                                                                    <span className="abiti-map-marker-label hera">
                                                                                        <span className="abiti-map-marker-dot hera"></span>
                                                                                        {abitiSelectedHera.address}
                                                                                        <button className="abiti-map-marker-remove" onClick={() => handleRemoveAbitiMarker('hera')} title="Rimuovi marker Hera">{'\u2715'}</button>
                                                                                    </span>
                                                                                )}
                                                                                {abitiSelectedInteracta && (
                                                                                    <span className="abiti-map-marker-label interacta">
                                                                                        <span className="abiti-map-marker-dot interacta"></span>
                                                                                        {abitiSelectedInteracta.address}
                                                                                        <button className="abiti-map-marker-remove" onClick={() => handleRemoveAbitiMarker('interacta')} title="Rimuovi marker Interacta">{'\u2715'}</button>
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ position: 'relative' }}>
                                                                            <div
                                                                                ref={abitiMapRef}
                                                                                className="abiti-detail-map"
                                                                            ></div>
                                                                            {abitiMapLoading && (
                                                                                <div className="abiti-map-loader-overlay">
                                                                                    <Lf23Loader className="abiti-map-loader-mini" testo={null} />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="abiti-no-detail-msg">
                                                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="1.5">
                                                                    <circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" />
                                                                </svg>
                                                                <p>Nessun dettaglio disponibile per questa data</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )
                            )}

                            {/* Table (COOP/ODS) */}
                            {selectedCategory !== "REPORT ABITI" && (tableLoading ? (
                                <Lf23Loader />
                            ) : filteredTableData.length > 0 ? (
                                <div className={`hera-table-section${isFullscreenTable ? ' fullscreen-hera' : ''}`}>
                                    <RotateDevice active={isFullscreenTable} />
                                    <div className="hera-table-section-header">
                                        <span className="hera-table-section-title">{selectedCategory}</span>
                                        <div className="hera-table-section-actions">
                                            <button className="hera-download-btn" onClick={handleDownloadFile} disabled={!selectedCategory || filteredTableData.length === 0}>
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                                    <polyline points="7 10 12 15 17 10"></polyline>
                                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                                </svg>
                                                Esporta
                                            </button>
                                            <button
                                                className="hera-fullscreen-btn"
                                                onClick={() => setIsFullscreenTable(!isFullscreenTable)}
                                                title={isFullscreenTable ? 'Esci da tutto schermo' : 'Tutto schermo'}
                                            >
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    {isFullscreenTable ? (
                                                        <><polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line></>
                                                    ) : (
                                                        <><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></>
                                                    )}
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="hera-table-wrapper">
                                        <table className="hera-table">
                                            <thead>
                                                <tr>
                                                    {colonne.map((col, index) => (
                                                        <th
                                                            key={col}
                                                            title={col}
                                                            onMouseEnter={(e) => handleColHover(col, e)}
                                                            onMouseLeave={handleColLeave}
                                                            onClick={() => handleSort(index)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between', minWidth: 0 }}>
                                                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
                                                                    {getColumnTitle(col)}
                                                                </span>
                                                                <span style={{ display: 'flex', flexDirection: 'column', opacity: sortConfig.column === col ? 1 : 0.3, flexShrink: 0 }}>
                                                                    <svg
                                                                        width="10"
                                                                        height="10"
                                                                        viewBox="0 0 24 24"
                                                                        fill={sortConfig.column === col && sortConfig.direction === 'asc' ? 'currentColor' : 'none'}
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                        style={{ marginBottom: '-4px' }}
                                                                    >
                                                                        <polyline points="18 15 12 9 6 15"></polyline>
                                                                    </svg>
                                                                    <svg
                                                                        width="10"
                                                                        height="10"
                                                                        viewBox="0 0 24 24"
                                                                        fill={sortConfig.column === col && sortConfig.direction === 'desc' ? 'currentColor' : 'none'}
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                    >
                                                                        <polyline points="6 9 12 15 18 9"></polyline>
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getSortedData().map((row, index) => (
                                                    <tr key={index} className={row.ignora ? 'hera-row-ignored' : ''}>
                                                        {Object.entries(row).map(([key, value], i) => (
                                                            <td key={i}>
                                                                {key === 'stato_errore' ? (
                                                                    <span className={`hera-badge hera-badge-${value}`}>
                                                                        {value === 'aperto' && (
                                                                            <>
                                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                    <circle cx="12" cy="12" r="10"></circle>
                                                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                                                </svg>
                                                                                Aperto
                                                                            </>
                                                                        )}
                                                                        {value === 'risolto' && (
                                                                            <>
                                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                                                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                                                                </svg>
                                                                                Risolto
                                                                            </>
                                                                        )}
                                                                        {value === 'non_in_errore' && (
                                                                            <>
                                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                    <circle cx="12" cy="12" r="10"></circle>
                                                                                    <line x1="8" y1="12" x2="16" y2="12"></line>
                                                                                </svg>
                                                                                NO ERR.
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                ) : key === 'ignora' ? (
                                                                    <label className="hera-checkbox-container">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={value || false}
                                                                            onChange={() => handleIgnoraToggle(row.servizio, value, row.note_ignora)}
                                                                        />
                                                                        <span className="hera-checkbox-checkmark"></span>
                                                                    </label>
                                                                ) : key === 'note_ignora' ? (
                                                                    <div className="hera-note-cell">
                                                                        {editingNoteServizio === row.servizio ? (
                                                                            <div className="hera-note-edit">
                                                                                <input
                                                                                    type="text"
                                                                                    className="hera-note-input"
                                                                                    value={editingNoteValue}
                                                                                    onChange={(e) => setEditingNoteValue(e.target.value)}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter') handleSaveNote(row.servizio, row.ignora);
                                                                                        if (e.key === 'Escape') {
                                                                                            setEditingNoteServizio(null);
                                                                                            setEditingNoteValue('');
                                                                                        }
                                                                                    }}
                                                                                    autoFocus
                                                                                />
                                                                                <button
                                                                                    className="hera-note-btn hera-note-btn-save"
                                                                                    onClick={() => handleSaveNote(row.servizio, row.ignora)}
                                                                                    title="Salva"
                                                                                >
                                                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                                                    </svg>
                                                                                </button>
                                                                                <button
                                                                                    className="hera-note-btn hera-note-btn-cancel"
                                                                                    onClick={() => {
                                                                                        setEditingNoteServizio(null);
                                                                                        setEditingNoteValue('');
                                                                                    }}
                                                                                    title="Annulla"
                                                                                >
                                                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <div
                                                                                className="hera-note-display"
                                                                                onClick={() => {
                                                                                    setEditingNoteServizio(row.servizio);
                                                                                    setEditingNoteValue(value || '');
                                                                                }}
                                                                            >
                                                                                {value ? (
                                                                                    <span className="hera-note-text">{value}</span>
                                                                                ) : (
                                                                                    <span className="hera-note-placeholder">
                                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                                                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                                                                        </svg>
                                                                                        Aggiungi nota
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ) : (value === 'X' && [
                                                                    'ods_con_giustificativo',
                                                                    'ods_ini_stato_fins_prog',
                                                                    'ods_non_inviati_corr_a_sdc_inviati_in_consunt',
                                                                    'ods_in_stato_asac_isac',
                                                                    'ods_gestiti_min_1_h',
                                                                    'ods_gestiti_magg_12_h',
                                                                    'ods_senza_letture_no_spazzamenti',
                                                                    'no_letture_servizi_da_agenda',
                                                                    'errori_tracking_spazzamento'
                                                                ].includes(key)) ? (
                                                                    <span className={`hera-x-icon ${row.stato_errore === 'risolto' ? 'hera-x-icon-green' : 'hera-x-icon-red'}`}>
                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                                                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                                                        </svg>
                                                                    </span>
                                                                ) : value}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="hera-empty-state">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                        <polyline points="14 2 14 8 20 8"></polyline>
                                        <line x1="16" y1="13" x2="8" y2="13"></line>
                                        <line x1="16" y1="17" x2="8" y2="17"></line>
                                    </svg>
                                    <p>
                                        {selectedCategory
                                            ? `Nessun dato trovato per ${selectedCategory} nel periodo selezionato.`
                                            : "Seleziona una categoria per visualizzare i dati"}
                                    </p>
                                </div>
                            ))}
                        </>
                    )}
                </div>

                {/* Tooltip */}
                {hoveredCol !== null && (
                    <div
                        className="hera-tooltip"
                        style={{
                            position: 'fixed',
                            left: `${tooltipPosition.x}px`,
                            top: `${tooltipPosition.y}px`,
                            transform: 'translate(-50%, -100%)',
                        }}
                    >
                        {getColumnTooltip(hoveredCol)}
                    </div>
                )}
            </main>
        </div>
    );
};

export default UploadReportHera;
